import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { fetchLogout } from "../../../store/reducers/authentication/apiThunk";
import { resetBag } from "../../../store/reducers/bag/apiThunk";

const LogoutModal = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(fetchLogout());
    dispatch(resetBag());
    onClose();
  };

  return (
    <Box className='logout-profile-modal'>
      <Typography className='logout-profile-modal-title'>
        Log out?
      </Typography>
      <Typography className='logout-profile-modal-body'>
        Are you sure you want to log out?
      </Typography>
      <Box className='logout-profile-modal-btns'>
        <Button
          variant='outlined'
          className='logout-profile-modal-cancel-btn'
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          className='logout-profile-modal-logout-btn'
          onClick={handleLogout}
        >
          Yes
        </Button>
      </Box>
    </Box>
  );
};

export default LogoutModal;
